import { Pipe, PipeTransform } from "@angular/core";
import { DataService } from "@bb-vendure/admin-ui/core";
import { map } from "rxjs";
import { EventIdolDocument } from "src/generated-gql/graphql";
import { Observable } from "rxjs";

@Pipe({
  name: "idolName",
  standalone: true,
})
export class IdolNamePipe implements PipeTransform {
  constructor(protected dataService: DataService) {}
  transform(value: number): Observable<string | undefined> {
    return this.dataService
      .query(EventIdolDocument, { id: value.toString() })
      .single$.pipe(map((res) => {
        console.log(res);
        return res.eventIdol?.name;
      }));
  }
}
